'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var svgVariantsStyles = {
    primary: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }),
    secondary: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.secondary;
    }),
    adminGreyDark: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }),
    adminGreyDarkWithHover: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminBlack;
    }),
    adminGreyMedium: styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMedium;
    }),
    adminGreyMediumAlt: styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMediumAlt;
    }),
    adminBlack: styled.css(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminBlack;
    }),
    white: styled.css(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }),
    pink: styled.css(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.pink;
    }),
    none: styled.css(templateObject_10 || (templateObject_10 = tslib_es6.__makeTemplateObject([""], [""]))),
};
var svgSizesStyles = {
    xs: styled.css(templateObject_11 || (templateObject_11 = tslib_es6.__makeTemplateObject(["\n    width: 12px;\n    height: 12px;\n  "], ["\n    width: 12px;\n    height: 12px;\n  "]))),
    sm: styled.css(templateObject_12 || (templateObject_12 = tslib_es6.__makeTemplateObject(["\n    width: 16px;\n    height: 16px;\n  "], ["\n    width: 16px;\n    height: 16px;\n  "]))),
    's/m': styled.css(templateObject_13 || (templateObject_13 = tslib_es6.__makeTemplateObject(["\n    width: 18px;\n    height: 18px;\n  "], ["\n    width: 18px;\n    height: 18px;\n  "]))),
    md: styled.css(templateObject_14 || (templateObject_14 = tslib_es6.__makeTemplateObject(["\n    width: 20px;\n    height: 20px;\n  "], ["\n    width: 20px;\n    height: 20px;\n  "]))),
    'm/l': styled.css(templateObject_15 || (templateObject_15 = tslib_es6.__makeTemplateObject(["\n  width: 22px;\n  height: 22px;\n"], ["\n  width: 22px;\n  height: 22px;\n"]))),
    lg: styled.css(templateObject_16 || (templateObject_16 = tslib_es6.__makeTemplateObject(["\n    width: 24px;\n    height: 24px;\n  "], ["\n    width: 24px;\n    height: 24px;\n  "]))),
    xlg: styled.css(templateObject_17 || (templateObject_17 = tslib_es6.__makeTemplateObject(["\n    width: 60px;\n    height: 60px;\n  "], ["\n    width: 60px;\n    height: 60px;\n  "]))),
    none: styled.css(templateObject_18 || (templateObject_18 = tslib_es6.__makeTemplateObject([""], [""]))),
};
var SvgIcon = styled__default.svg(templateObject_19 || (templateObject_19 = tslib_es6.__makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'primary' : _b;
    return svgVariantsStyles[variant];
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b, styling = _a.styling;
    return (styling || svgSizesStyles[size]);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;

exports.SvgIcon = SvgIcon;
